import multiUserPlanManagementApi from "@/api/multi-user-plan-management";
import events from "@/events/index";
import teamsApi from "@/api/teams";
import i18n from "@/modules/i18n";

const state = {
  hasB2cOrg: null,
  inviteLink: null,
  invitees: null,
  isFull: null,
  memberToRemove: null,
  eligibleForMUP: false
};

const mutations = {
  hasB2cOrg: (state, payload) => {
    state.hasB2cOrg = payload;
  },
  eligibleForMUP: (state, payload) => {
    state.eligibleForMUP = payload;
  },
  inviteLink: (state, payload) => {
    state.inviteLink = payload;
  },
  invitees: (state, payload) => {
    state.invitees = payload;
  },
  isFull: (state, payload) => {
    state.isFull = payload;
  },
  memberToRemove: (state, payload) => {
    state.memberToRemove = payload;
  }
};

const actions = {
  fetchOwnerOrg: async ({ commit }) => {
    try {
      const res = await multiUserPlanManagementApi.fetchOwnerOrg();
      commit("eligibleForMUP", res.mupEligible);
      commit("invitees", res.invitees);
      commit("inviteLink", res.inviteLink);
      commit("hasB2cOrg", !!res.organisationId);
      commit("isFull", res.isFull);
    } catch (_) {
      commit("hasB2cOrg", false);
    }
  },
  createOwnerOrg: ({ commit }) => {
    return multiUserPlanManagementApi
      .createOwnerOrg()
      .then(res => {
        if (res.status === "error") {
          throw res.message;
        } else {
          commit("hasB2cOrg", true);
          commit("inviteLink", res.inviteLink);
          commit("invitees", res.invitees);
          commit("isFull", res.isFull);

          events.track("mup_settings_members_shown", "1-show");
        }
      })
      .catch(() => {
        commit("hasB2cOrg", false);
      });
  },
  triggerRemoveUserModal: ({ commit }, member) => {
    events.emit("modal:remove-mup-member-modal:open");
    commit("memberToRemove", member);
  },
  removeUser: ({ state, dispatch }) => {
    return teamsApi
      .removeUserFromTeam(state.memberToRemove.userId)
      .then((res) => {
        if (res.status === "error") {
          throw res.message;
        } else {
          dispatch("toaster/push", {
            id: "api/removeUserSuccess",
            message: i18n.t("pages.settings.mup.userRemovedSuccess"),
            type: "success"
          }, { root: true });
        }
      })
      .catch(() => {
        dispatch("toaster/push", {
          id: "api/removeUserError",
          message: i18n.t("errors.generic"),
          type: "error"
        }, { root: true });
      })
      .finally(() => {
        dispatch("fetchOwnerOrg");
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
